import React from "react";

const LinearLoader = ({ visible = false }) => {
  if (!visible) return null;

  return (
    <div className="linearLoader">
      <div className="linearLoaderTrack" />
      <div className="linearLoaderBar" />
    </div>
  );
};

export default LinearLoader;
